export enum ButtonStyles {
    Anchor = "-anchor",
    AnchorBlue = "-anchor -blue",
    Destructive = "-destructive",
    Primary = "-primary",
    Secondary = "-secondary",
    Success = "-success",
    Tertiary = "-tertiary",
    TertiaryAlt = "-tertiary-alt",
    Text = "-text",
    None = "",
    RoundedPrimary = "-rounded-primary",
    RoundedSecondary = "-rounded-secondary",
    Quaternary = "-quaternary",
}
